import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="match-height"
export default class extends Controller {
  static targets = ["source", "target"];

  connect() {
    this.mediaQuery = window.matchMedia("(min-width: 1024px)");
    this.sync = this.sync.bind(this);

    this.resizeObserver = new ResizeObserver(this.sync);
    this.resizeObserver.observe(this.sourceTarget);
    this.mediaQuery.addEventListener("change", this.sync);

    this.sync();
  }

  disconnect() {
    this.resizeObserver?.disconnect();
    this.mediaQuery?.removeEventListener("change", this.sync);
  }

  sync() {
    if (this.mediaQuery.matches) {
      const height = this.sourceTarget.getBoundingClientRect().height;
      this.targetTarget.style.maxHeight = `${height}px`;
    } else {
      this.targetTarget.style.maxHeight = "";
    }
  }
}
